<template>
  <div style="width: 100%">
    <v-autocomplete
        v-model="services"
        :items="searchResults"
        :loading="isLoading"
        item-text="desc"
        item-value="_id"
        :label="$t('servicesCenter')"
        :placeholder="$t('startTypingToSearch')"
        @change="setResult()"
        deletable-chips
        multiple
        chips
        small-chips
        return-object
        :hint="(searchResults.length == 0 && showHint) ? $t('noResults'):''"
    ></v-autocomplete>
  </div>

</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "ServicesAutocomplete",
  props: {
    model: {
      default: () => ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    services: [],
    searchResults: [],
    isLoading: false,
    search: null,
    showHint: false
  }),
  async created() {

    this.isLoading = true
    var result = await this.getItems()
    if (result.length > 0) {

      result.sort((a, b) => a.name.localeCompare(b.name)).filter

      result.map(x => this.searchResults.push({
        'desc': x.name,
        '_id': x._id
      }))


      if(this.model.length > 0){
        this.model.map(x => {
          var find = _.find(result,{'_id':x})
          if(find){
            this.services.push(find)
          }
        })
      }

    } else {
      this.showHint = true
    }
    this.isLoading = false
  },
  watch: {
  },
  methods:{
    ...mapActions({
      'getItems':'services/index'
    }),
    setResult() {
      if(this.services.length > 0){
        this.$emit('message',this.services)
      }else {
        this.$emit('message','')
      }
    }
  }

}
</script>

<style scoped>

</style>